import { Component, OnDestroy } from '@angular/core';
import { ViewTaskflowComponent } from 'components/task/taskflow/view-taskflow.component';
import { CredentialType } from 'enums/CredentialType';
import { CommunicationLogEntryModel } from 'models/generated/Communication.Api.Models.CommunicationLogEntry';
import { TaskActionModel } from 'models/generated/Entities.GormCrm.TaskAction';
import { TaskflowModel } from 'models/generated/Entities.GormCrm.Taskflow';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { PushService } from 'services/push.service';
import { TaskService } from 'services/task.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'opencalls',
	templateUrl: './opencalls.component.html',
	imports: [Layout, ListView, TranslatePipe, CustomDatePipe]
})
@ComponentUrl('opencalls')
@CredentialRequired(CredentialType.BetaUserAccess)
export class OpenCallsComponent implements OnDestroy {

	opencalls: TaskActionModel[] = [];
	onTaskflowChanges: Subscription;

	activeViewTaskflowComponent?: ViewTaskflowComponent;

	constructor(private readonly taskService: TaskService,
		private readonly pushService: PushService,
		private readonly navigation: NavigationService,
		private readonly userService: UserService) {

		this.updateOpenCallsList();
		this.onTaskflowChanges = this.pushService.onTaskflowChanges.subscribe(event => {

			if (this.opencalls
				.filter(r => r.identifierObject === TaskflowModel)
				.filter(r => r.identifierId === event.data.taskflowId)
				.length > 0) {
				this.updateOpenCallsList();
			}
		});
	}

	updateOpenCallsList() {
		this.taskService.getUsersOpenSalesflows(this.userService.getCurrentUser().id!).then(taskActions => {
			this.opencalls = taskActions;
		});
	}

	getLatestStatus(taskAction: TaskActionModel) {
		const latestStatus = this.getLatestLogEntry(taskAction.taskflow!).statusType ?? 'na';
		return 'communicationlog.status.' + latestStatus;
	}

	getLatestLogEntry(taskflow: TaskflowModel): CommunicationLogEntryModel {

		let communicationLog: CommunicationLogEntryModel[] = [];

		for (let taskAction of taskflow.taskActions) {
			communicationLog = communicationLog.concat(taskAction.communicationLogEntries);
		}
		communicationLog.sort((a, b) => (b.timestamp ? new Date(b.timestamp).getTime() : new Date(0).getTime()) - (a.timestamp ? new Date(a.timestamp).getTime() : new Date(0).getTime()));
		return communicationLog.length > 0 && communicationLog[0].statusType ? communicationLog[0] : new CommunicationLogEntryModel();
	}

	ngOnDestroy() {
		this.onTaskflowChanges.unsubscribe();
	}

	displayTaskflow(taskflow?: TaskflowModel) {
		if (taskflow) {
			this.navigation.openRelativeView(this, 'taskflow', ViewTaskflowComponent).then(c => {
				this.activeViewTaskflowComponent = c;
				c.taskflowId = taskflow.id as string;
			});
		}
	}
} 
